module.exports = __webpack_public_path__ + "img/horizontal_4_3_pp3_6005.435886da.png";